<template>
  <span>

    <b-container fluid>
      <b-row class="table-header">

        <b-col cols="12" lg="6" xl="9">
          <b-form-group v-if="context === 'select'">
            <b-button
              variant="outline-secondary"
              @click="removeAll">
              <i class="fas fa-minus"></i>
              Remove All
            </b-button>
          </b-form-group>
        </b-col>

        <b-col cols="12" lg="6" xl="3">
          <b-form-group>
            <b-form-input
              ref="search"
              v-model="meta.search"
              :disabled="fetching"
              placeholder="Search name or description"
              @keyup.native="search"
              @input="searchChanged"/>
          </b-form-group>
        </b-col>
      </b-row>

      <no-data v-if="noData" message="No groups found..."/>

      <b-table
        v-if="tableData.length"
        ref="table"
        :hover="rowClickEnabled && !fetching"
        :busy="fetching"
        :responsive="true"
        :items="tableData"
        :fields="formFields"
        :per-page="Number(meta.per_page)"
        :sort-by="meta.order"
        :sort-desc="meta.desc"
        :no-local-sorting="true"
        @sort-changed="sortChanged"
        @row-clicked="rowClicked">

        <template slot="name" slot-scope="data">
          <span class="name">
            {{ data.value }}
          </span>
        </template>

        <template slot="created" slot-scope="data">
          <div class="no-wrap">
            {{ readableDate(data.value) }}
          </div>
        </template>

        <template slot="status" slot-scope="data">
          <span :class="{'bad-value': data.value ==='inactive'}">
            {{ data.value }}
          </span>
        </template>

        <template slot="relations" slot-scope="data">
          <div class="no-wrap">
            <span
              v-b-tooltip.hover
              v-if="data.value.members"
              title="members">
              <i class="fas fa-user"></i>
              {{ data.value.members.length }}
              &nbsp;
            </span>
            <span
              v-b-tooltip.hover
              v-if="data.value.modules"
              title="modules">
              <i class="fas fa-folder"></i>
              {{ data.value.modules.length }}
              &nbsp;
            </span>
          </div>
        </template>

        <template slot="actions" slot-scope="data">
          <div v-if="archived" class="no-wrap">
            <span v-b-tooltip.hover style="display:inline-block" title="restore">
              <b-button
                :disabled="fetching"
                variant="outline-secondary"
                @click.stop="restore(data.item.id)">
                <i class="fas fa-check"></i>
              </b-button>
            </span>
          </div>
          <div v-else class="no-wrap">
            <span v-b-tooltip.hover style="display:inline-block" title="edit">
              <b-button
                :disabled="fetching"
                title="edit"
                variant="outline-secondary"
                @click.stop="edit(data.item.id)">
                <i class="fas fa-cog"></i>
              </b-button>
            </span>
            <span v-b-tooltip.hover style="display:inline-block" title="archive">
              <b-button
                :disabled="fetching"
                title="archive"
                variant="outline-secondary"
                @click.stop="archive(data.item.id)">
                <i class="fas fa-archive"></i>
              </b-button>
            </span>
          </div>
        </template>

      </b-table>

      <b-row>
        <b-col cols="12">
          <b-pagination
            v-if="data.length"
            :disabled="fetching"
            :value="Number(meta.current_page)"
            :total-rows="Number(meta.total)"
            :per-page="Number(meta.per_page)"
            @change="pageChanged"/>
        </b-col>
      </b-row>

    </b-container>
  </span>
</template>

<script>
import tableMixin from '../../mixins/admin-table'

export default {
  mixins: [tableMixin],
  props: {
    context: {
      type: String,
      required: false,
      default: 'page'
    },
    idsToHighlight: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data () {
    return {
      editRoute: 'admin-edit-group',
      namespace: 'groups',
      routeParamName: 'group',
      rowClickRoute: 'admin-components'
    }
  },
  computed: {
    formFields () {
      if (this.context === 'page') {
        return [
          { key: 'name', label: 'Name', sortable: true },
          { key: 'created', label: 'Created', sortable: true },
          { key: 'relations', label: 'Relations' },
          { key: 'actions', label: 'Actions' }
        ]
      } else {
        return [
          { key: 'name', label: 'Name', sortable: true },
          { key: 'created', label: 'Created', sortable: true },
          { key: 'relations', label: 'Relations' }
        ]
      }
    },
    tableData () {
      return this.data.map((group) => {
        let _rowVariant = null
        if (this.idsToHighlight.indexOf(group.id) !== -1) {
          _rowVariant = 'success'
        }
        return { ...group, _rowVariant }
      })
    }
  },
  methods: {
    rowClicked (item, index, e) {
      if (this.rowClickEnabled) {
        this.$emit('selectGroup', item)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/groups/table.vue